<template>
  <vf-accordion
    v-for="({ data, expanded: opened, label, layout = 'grid' }, i) in productDetails"
    :key="i"
    :class="{ 'b-b': i === productDetails.length - 1 }"
    :open="allowOpenedAccordions && opened"
    variant="aligned"
  >
    <template #toggle="{ expanded }">
      <span class="flex items-center py-4 between" data-test-id="vf-accordion-toggle">
        <span class="elevate-body-2 truncate fw-bold">
          {{ label }}
        </span>
        <vf-icon :name="expanded ? 'minus' : 'plus'" size="lg" />
      </span>
    </template>
    <div class="elevate-body-3 pb-5">
      <component
        :is="componentTypes[DETAIL_LAYOUTS.includes(layout) ? layout : 'detailCard']"
        :data
        :title="label"
      />
    </div>
  </vf-accordion>
</template>

<script setup lang="ts">
import type { ProductDetails } from '#root/api/clients/product/data-contracts'
import {
  LazyProductAccordionsBulletin,
  LazyProductAccordionsDetailCard,
  LazyProductAccordionsGrid,
  LazyProductAccordionsKeyValue,
  LazyProductAccordionsModalGrid,
  LazyProductAccordionsScale
} from '#components'
import { DETAIL_LAYOUTS } from '#types/product'

defineProps<{
  productDetails: ProductDetails[]
  allowOpenedAccordions?: boolean
}>()

const componentTypes = {
  bulletin: LazyProductAccordionsBulletin,
  detailCard: LazyProductAccordionsDetailCard,
  grid: LazyProductAccordionsGrid,
  keyValue: LazyProductAccordionsKeyValue,
  modalGrid: LazyProductAccordionsModalGrid,
  scale: LazyProductAccordionsScale
}
</script>
